import { Fragment, useEffect, useCallback } from "react";
import * as Scrivito from "scrivito";
import { Helmet } from "react-helmet-async";

import LoginButton from "^/Components/Navigation/LoginButton";
import { useAuth } from "^/Components/Authentication/AuthenticationProvider";
import { getKeycloak } from "^/Components/Authentication/keycloak";

const NotFoundErrorPage = () => {
  const backgroundImage = [
    "linear-gradient(rgba(46, 53, 60, 0.3), rgba(46, 53, 60, 0.2))",
    "url(https://unsplash.com/photos/Bs0zgYkYEZw/download)",
  ].join(", ");

  const language = window.location.pathname.includes("/en/") ? "en" : "de";
  const homepage = Scrivito.Obj.onSite(language)
    .where("_objClass", "equals", "Homepage")
    .first();
  const redirectUri = window.location.href;
  const currentPathname = window.location.pathname;
  const { authenticated, initialized } = useAuth();

  const redirectToLogin = useCallback(() => {
    getKeycloak().login({
      redirectUri,
    });
  }, [redirectUri]);

  useEffect(() => {
    if (
      !authenticated &&
      initialized &&
      currentPathname.includes("/intranet/")
    ) {
      redirectToLogin();
    }
  }, [authenticated, initialized, currentPathname, redirectToLogin]);

  return (
    <Fragment>
      <section
        className="bg-dark-image full-height"
        style={{ background: "no-repeat center / cover", backgroundImage }}
      >
        <div className="container">
          <div className="text-center">
            <h1 className="hero-bold">Ooops</h1>
          </div>
          <div className="text-center">
            <h2 className="hero-small">
              {authenticated
                ? "Die Seite die Sie suchen, existiert nicht."
                : "Die Seite die Sie suchen, existiert nicht oder benötigt einen Login."}
            </h2>
            <h2 className="hero-small">
              {authenticated
                ? "The page you are looking for does not exist."
                : "The page you are looking for does not exist or needs a Login."}
            </h2>
          </div>
          <div className="text-center mb-4">
            <Scrivito.LinkTag to={homepage} className="btn bg-yellow">
              Go to mainpage{" "}
              <i className="las la-angle-right is-100" aria-hidden="true" />
            </Scrivito.LinkTag>

            {!authenticated && (
              <LoginButton
                homepage={homepage}
                className="btn bg-yellow d-block d-sm-inline mx-auto ms-sm-3 mt-3 mt-sm-0"
                title="Login to Intranet"
                redirectUri={redirectUri}
              />
            )}
          </div>
        </div>
      </section>
      <Helmet meta={[{ name: "prerender-status-code", content: "404" }]} />
    </Fragment>
  );
};

const ConnectedNotFoundErrorPage = Scrivito.connect(NotFoundErrorPage);

export default () => (
  <Scrivito.NotFoundErrorPage>
    <ConnectedNotFoundErrorPage />
  </Scrivito.NotFoundErrorPage>
);
